const addTagsParameters = [];

export function loadZendeskScript({ user }) {
  const scriptElement = document.createElement('script');
  const firstScriptElement = document.getElementsByTagName('script')[0];

  scriptElement.type = 'text/javascript';
  scriptElement.async = true;
  scriptElement.id = 'ze-snippet';
  scriptElement.src = 'https://static.zdassets.com/ekr/snippet.js?key=d6ec31c8-d474-42e0-95a4-34e059c6136f';

  firstScriptElement.parentNode.insertBefore(scriptElement, firstScriptElement);

  scriptElement.addEventListener('load', () => {
    startZendesk({ user });
  });
}

function jwtFn(callback) {
  fetch('/zendesk/jwt').then((res) => {
    res.text().then((jwt) => {
      const parsedJwt = JSON.parse(jwt);

      if (parsedJwt.status === 'DATA') {
        return callback(parsedJwt.message);
      }
    });
  });
}

function startZendesk({ user }) {
  const lang = 'pt';

  addTagsParameters.push([`idioma_${lang}`]);

  window.zE(function () {
    window.$zopim(function () {
      window.$zopim.livechat.addTags(...addTagsParameters);
    });
  });

  const preFillData = {
    name: {
      value: user.name,
      readOnly: true, // optional
    },
    email: {
      value: user.email,
      readOnly: true, // optional
    },
  };

  window.zE('webWidget', 'setLocale', 'pt-br');
  window.zE('webWidget', 'prefill', preFillData);

  window.zESettings = {
    webWidget: {
      authenticate: {
        chat: jwtFn,
      },
    },
  };
}
